export const APPCONFIG = {
    
    SITE: {
        WEBAPP: process.env.REACT_APP_URL_WEBAPP,
        WEBAPI: process.env.REACT_APP_URL_WEBAPI,
        WEBNH: process.env.REACT_APP_URL_BASENH,
        WEBHUB: process.env.REACT_APP_URL_HUB
    },

    TIPOADJUNTO: {
        AUTORIZACION: ['image/jpeg', 'image/jpg', 'image/jfif', 'image/png', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        CONFORMIDAD: ['image/jpeg', 'image/jpg', 'image/jfif', 'image/png', 'application/pdf'],
        REFERENCIADO: ['image/jpeg', 'image/jpg', 'image/jfif', 'image/png', 'application/pdf'],
        REMITO: ['image/jpeg', 'image/jpg', 'image/jfif', 'image/png', 'application/pdf'],
        COTIZACION: ['application/pdf']        
    },

    SIZEARCHIVO: {
        AUTORIZACION: { SIZE : 3000000, INFO: '3MB' },
        CONFORMIDAD: { SIZE : 3000000, INFO: '3MB' },
        REFERENCIADO: { SIZE : 3000000, INFO: '3MB' },
        REMITO: { SIZE : 3000000, INFO: '3MB' }           
    }
}
